import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from '@lingui/macro';
import { Text } from 'rebass';
import { List, UploadItem } from '@oca/ui';
import { bytesToSize } from '@lib/filesize';
import { Delete } from '@oca/icons';

export const RejectedFileList = React.memo(function RejectedFileList({
  items,
  onDelete,
  validation,
  ...rest
}) {
  return (
    <List
      {...rest}
      items={items}
      renderItem={(file, index) => {
        let statusText = <Trans>Rejected</Trans>;
        if (validation.accept && !file.type.startsWith(validation.accept)) {
          statusText = (
            <Trans>This file type {file.type} is not supported</Trans>
          );
        }
        if (validation.maxSize && file.size > validation.maxSize) {
          statusText = (
            <Trans>
              File is {bytesToSize(file.size)}. Max size is{' '}
              {bytesToSize(validation.maxSize)}
            </Trans>
          );
        }

        return (
          <UploadItem
            key={file.name}
            id={file.name}
            title={file.name}
            statusText={
              <Text as="span" color="error">
                {statusText}
              </Text>
            }
            onDelete={onDelete}
            renderActions={
              onDelete
                ? id => (
                    <UploadItem.Action
                      onClick={event => onDelete(id, index, event)}
                    >
                      <Delete />
                    </UploadItem.Action>
                  )
                : undefined
            }
            error
          />
        );
      }}
    />
  );
});

RejectedFileList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.string,
      filename: PropTypes.string,
      temp: PropTypes.bool,
    }),
  ).isRequired,
  // eslint-disable-next-line react/require-default-props
  onDelete: PropTypes.func,
  validation: PropTypes.shape({
    size: PropTypes.number,
    accept: PropTypes.string,
  }).isRequired,
};
